import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.scss']
})
export class MessagePopupComponent implements OnInit {
  @Input() public data$;
  translationLet: any;

  constructor(public activeModal: NgbActiveModal) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  onConfirm() {
    this.activeModal.close(true);
  }

  // onCancel() {
  //   this.activeModal.close(false);
  // }
  varIsArray(_var: any) {
    return Array.isArray(_var);
  }
}
